import { render, staticRenderFns } from "./Locales.vue?vue&type=template&id=06ab01d6&scoped=true&"
import script from "./Locales.vue?vue&type=script&lang=js&"
export * from "./Locales.vue?vue&type=script&lang=js&"
import style0 from "./Locales.vue?vue&type=style&index=0&id=06ab01d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ab01d6",
  null
  
)

export default component.exports